import { render, staticRenderFns } from "./freeGpts.vue?vue&type=template&id=26b808d8&scoped=true"
import script from "./freeGpts.vue?vue&type=script&lang=js"
export * from "./freeGpts.vue?vue&type=script&lang=js"
import style0 from "./freeGpts.vue?vue&type=style&index=0&id=26b808d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b808d8",
  null
  
)

export default component.exports